type Props = {
  disabled?: boolean;
};

export const SendIcon = ({ disabled = false }: Props) => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.6 8.00096L3.73205 2.69029C3.67002 2.66645 3.60229 2.66158 3.53749 2.6763C3.47268 2.69101 3.4137 2.72466 3.36805 2.77296C3.32106 2.82254 3.28871 2.88416 3.27459 2.951C3.26047 3.01783 3.26513 3.08727 3.28805 3.15162L4.93338 8.00096M14.6 8.00096L3.73205 13.3116C3.67002 13.3355 3.60229 13.3403 3.53749 13.3256C3.47268 13.3109 3.4137 13.2773 3.36805 13.229C3.32106 13.1794 3.28871 13.1178 3.27459 13.0509C3.26047 12.9841 3.26513 12.9146 3.28805 12.8503L4.93338 8.00096M14.6 8.00096H4.93338"
        stroke={disabled ? '#9C99A6' : 'white'}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
